<template>
  <div>
    <div class="top-img">
      <img
        src="./banner-pc-img/xwzx_xwzx_1920337.5@1x-tuya.png"
        alt=""
      />
    </div>
    <div class="content" v-show="!showLoading">
      <div class="all" v-for="(item,index) in dataList" :key="index" @click="clickJump(item)">
        <div class="left-img">
          <img :src="item.image" alt=""/>
        </div>
        <div class="right-content">
          <div class="title"><span>{{item.title}}</span></div>
          <p class="p-con">{{item.describe}}</p>
          <div class="reader">{{item.createTime.slice(0,10)}} </div>
        </div>
      </div>
      <div class="table-fenye">
        <el-pagination class="fenye-box" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <div class="loading-box" v-show="showLoading">
      <div class="loading-content" >
        <div class="point1"></div>
        <div class="point2"></div>
        <div class="point3"></div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "../api"
export default {
  data () {
    return {
      dataList:[],
      currentPage:1,
      showLoading:true,
      pageSize:5,
      total:0,

    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData(){
        this.showLoading = true
         api.getDataApi(1,this.currentPage,this.pageSize).then(res=>{
            console.log(res.data,"aaa");
            if(res){
              this.showLoading = false
              this.dataList = res.data.list
              this.total = res.data.total
            }else{
              this.showLoading = true
            }
          })
    },
    clickJump(item){
      window.open(`${item.jumpUrl}`)
    },
    handleCurrentChange(i){
        console.log(i);
        this.currentPage = i
        this.getData()

    }
  }
}
</script>
<style lang="less" scoped>
.top-img {
  width: 100%;
  height: 450px;
  overflow: hidden;
  > img {
    width: 100%;
    height: 100%;
  }
}
.content {
  width: 70%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
  padding: 20px 16px;
  > .all {
      box-sizing: border-box;
    margin: 40px auto;
    width: 100%;
    background-color: #f7f7f7;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    > .left-img {
      width: 35%;
      height: 310px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    > .right-content {
        width: 65%;
        height: 310px;
        text-align: left;
        display: flex;
        flex-direction: column;
        padding: 20px;
        .title{
          width: 100%;
          font-size: 30px;
          padding-bottom: 15px;
          color: #333;
          cursor: pointer;
          transition: all 0.2s linear;
          letter-spacing: 2px;
          white-space: nowrap; //禁止换行
          overflow: hidden;
          text-overflow: ellipsis; 
          &:hover {
            color: #2abbc3;
          }
        }
        p{
          width: 100%;
          flex: 1;
          font-size: 21px;
          padding-left: 8px;
          color: #333;
          cursor: pointer;
          transition: all 0.3s linear;
          letter-spacing: 2px;
          display: -webkit-box; //对象作为弹性伸缩盒子模型显示
          -webkit-box-orient: vertical; //设置或检索伸缩盒对象的子元素的排列方式
          -webkit-line-clamp: 5; //溢出省略的界限
          overflow: hidden; //设置隐藏溢出元素
          margin-top: 12px;
          margin-bottom: 8px;
          line-height: 28.5px;
          span{
            display: -webkit-box; //对象作为弹性伸缩盒子模型显示
            -webkit-box-orient: vertical; //设置或检索伸缩盒对象的子元素的排列方式
            -webkit-line-clamp: 4; //溢出省略的界限
            overflow: hidden; //设置隐藏溢出元素
          }
          &:hover {
            color: #2abbc3;
          }
        }
        .reader{
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          letter-spacing: 1px;
          color: #999;
          font-size: 20px;
          margin-top: 10px;
        }
    }
  }
  .table-fenye{
                    width: 100%;
                    height: 75px;
                    background-color: #fff;
                    margin-top: 20px;
                    padding-right: 40px;
                    .fenye-box{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                    }
                    /deep/ .btn-prev{
                            color: rgba(0,0,0,.65);
                            border-color: #d9d9d9;
                            background-color: #fff;
                            border: 1px solid #d9d9d9;
                            border-radius: 5px;
                            padding: 0px!important;
                            width: 40px;
                            height: 44px;
                            line-height: 44px;
                            margin-left: 13px;
                            i{
                                font-size: 24px!important;
                                font-weight: 500;
                                color: rgba(0,0,0,.65);
                            }
                        }
                        /deep/ .number{
                            color: rgba(0,0,0,.65);
                            border-color: #d9d9d9;
                            background-color: #fff;
                            border: 1px solid #d9d9d9;
                            border-radius: 5px;
                            padding: 0px!important;
                            min-width: 43px;
                            padding: 0 6px!important;
                            height: 44px;
                            line-height: 44px;
                            font-size: 22px!important;
                            font-weight: 500;
                            color: rgba(0,0,0,.65);
                            margin-left: 13px;
                            transition: all 0.2s linear;
                        }
                        /deep/ .number:hover{
                            border-color: #1890ff;
                            color: #1890ff;
                        }
                        /deep/ .active{
                            border-color: #1890ff;
                            color: #1890ff; 
                        }
                        /deep/ .btn-quickprev{
                            width: 40px;
                            height: 44px;
                            line-height: 44px;
                        }
                        /deep/ .btn-quicknext{
                            width: 40px;
                            height: 44px;
                            line-height: 44px;
                        }
                        /deep/ .btn-next{
                            color: rgba(0,0,0,.65);
                            border-color: #d9d9d9;
                            background-color: #fff;
                            border: 1px solid #d9d9d9;
                            border-radius: 5px;
                            padding: 0px!important;
                            width: 43px;
                            height: 44px;
                            line-height: 44px;
                            margin-left: 13px;
                            i{
                                font-size: 24px!important;
                                font-weight: 500;
                                color: rgba(0,0,0,.65);
                            }
                        }
                        /deep/ .el-pagination__jump{
                            width: 140px;
                            height: 44px;
                            line-height: 44px;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                        }
                        /deep/ .el-input{
                            width: 60px;
                            height: 44px;
                            line-height: 44px;
                            padding: 0px!important;
                        }
                        /deep/ .el-pagination__editor{
                            margin: 0px!important;
                        }
                        /deep/ .el-input__inner{
                            width: 60px;
                            height: 44px;
                            line-height: 44px;
                            padding: 0px!important;
                            font-size: 22px!important;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        /deep/ .el-pagination__total{
                            font-size: 22px;
                        }
                        /deep/ .el-pagination__jump{
                            font-size: 22px;
                        }
  }
}
.loading-box{
   width: 66%;
   height: 800px;
   margin: 0 auto;
   background-color: #fff;
   margin-bottom: 30px;
   position: relative;
   .loading-content{
                width: 150px;
                height: 100px;
                text-align: center;
                line-height: 100px;
                position: absolute;
                top: 0px;
                right: 0;
                left: 0;
                bottom: 0;
                margin: auto;
                div {
                    width: 15px;
                    height: 15px;
                    background-color: blue;
                    border-radius: 100%;
                    display: inline-block;
                    animation: action 1.5s infinite ease-in-out;
                    animation-fill-mode: both;
                    margin-right: 15px;
                }
                .point1 {
                    animation-delay: -0.3s;
                }
                .point2 {
                    animation-delay: -0.1s;
                }
            }
            @keyframes action {
                0%, 80%, 100% {
                    transform: scale(0);
                }
                40% {
                    transform: scale(1.0);
                }
            }
        }
</style>